import { AsyncIterableX } from './asynciterablex';
import { extremaBy, defaultCompareAsync } from './_extremaby';

export function maxBy<TSource, TKey>(
  source: AsyncIterable<TSource>,
  keySelector: (x: TSource) => TKey | Promise<TKey>,
  comparer: (x: TKey, y: TKey) => number | Promise<number> = defaultCompareAsync
): AsyncIterableX<TSource> {
  return extremaBy(source, keySelector, comparer);
}



// WEBPACK FOOTER //
// ./node_modules/ix/asynciterable/maxby.ts